<template>
  <input
    class="tw-w-full tw-py-2 tw-px-4 tw-bg-neutral-100 tw-rounded-md tw-border-none tw-shadow"
  />
</template>
<script setup lang="ts"></script>
<style scoped></style>
